import React from 'react';

import classes from '../utils/cssClasses';
import style from './loading.scss';

export default () => {
	return (
			<img  className={classes('badge-app-loading',style)} src="/loader.gif" alt=""/>
		)
}


// WEBPACK FOOTER //
// ./src/components/Loading.js